import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    wrapper: {
        width: '100%',
        height: '100%',
    },
    loadingIndicator: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        maxHeight: '300px',
        scrollbarWidth: 'thin',

        '&::-webkit-scrollbar': {
            width: 3.5,
            height: 3.5,
        },

        '&::-webkit-scrollbar-thumb': {
            background: '#d0d0d0',
            borderRadius: 7,
        },

        '& tr': {
            padding: '0px 16px',
            [theme.breakpoints.down('md')]: {
                fontSize: '12px',
            },
        },

        '& th': {
            padding: '4px 16px',

            [theme.breakpoints.down('md')]: {
                fontSize: '12px',
            },
        },

        '& td': {
            padding: '4px 16px',

            [theme.breakpoints.down('md')]: {
                fontSize: '12px',
            },
        },
    },
    lastChildFixed: {
        '& th': {
            '&:last-child': {
                position: 'sticky',
                right: 0,
                zIndex: 3,
            },
        },

        '& td': {
            '&:last-child': {
                position: 'sticky',
                right: 0,
            },
        },
    },
    firstChildFixed: {
        '& th': {
            '&:first-child': {
                position: 'sticky',
                left: 0,
                zIndex: 3,
            },
        },

        '& td': {
            '&:first-child': {
                position: 'sticky',
                left: 0,
            },
        },
    },
    button: {
        backgroundColor: 'hsl(43deg 100% 46%)',
        color: 'white',
        textTransform: 'none',
    },
    toggleButton: {
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    tableHeaderCell: {
        whiteSpace: 'nowrap',
        alignContent: 'center',
        alignItems: 'center',
        display: 'flex',
    },
    tableHeaderSortIcon: {
        padding: 6,
        marginLeft: 5,
    },
    tableRow: {
        padding: '0px 16px',

        '&:nth-of-type(even)': {
            backgroundColor: '#f8f8f8',
        },
    },
    tableFooter: {
        position: 'sticky',
        bottom: 0,

        '& td': {
            position: 'sticky',
            bottom: 0,
            backgroundColor: '#f4f6f8',
            fontWeight: 'bold',
            color: theme.palette.text.primary,
            fontSize: 14,
        },
    },
}));
